<template>
  <div class="AddCustomerBasicInfo">
    <QS-h4-title title="客户基本信息">
      <template #right>
        <AlipayAnxinCard
          v-if="showAlipayAnxinCard"
          @data="handleAlipayAnxinCardData"
        />
      </template>
    </QS-h4-title>
    <el-form
      :model="publicInfo"
      ref="addCustomerBasicInfo"
      :rules="formRule"
      label-width="140px"
    >
      <!-- 照片 -->
      <!-- <column-box
        :column="2"
        label-width="60px"
      > -->
        <el-row>
          <el-col :span="8">
            <el-form-item
              v-if="addFormData.customerType == 1"
              prop="idCard"
              :label="'身份证照片（正）' + columnSeparator"
            >
              <UploadCommon
                fileTitle="(ocr识别)"
                :fileList="idCardUrl"
                :isAlone="true"
                @uploadSuccess="idCardSuccess"
                @deleteUploadHandle="delIdCardUrl"
                :sizeType="4"
                commonUpload
                group="driver"
                code="driver_legal_id_card_front_pic"
              ></UploadCommon>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              v-if="addFormData.customerType == 1"
              prop="idCardBack"
              :label="'身份证照片（背）' + columnSeparator"
            >
              <UploadCommon
                fileTitle="(ocr识别)"
                :fileList="idCardBackUrl"
                :isAlone="true"
                @uploadSuccess="idCardBackSuccess"
                @deleteUploadHandle="delIdCardBackUrl"
                :sizeType="4"
                commonUpload
                group="driver"
                code="driver_legal_id_card_back_pic"
              ></UploadCommon>
            </el-form-item>
          </el-col>
        </el-row>

        <el-col :span="24">
          <el-form-item
            v-if="addFormData.customerType == 2"
            prop="businessLicenceUrl"
            :label="'营业执照照片' + columnSeparator"
          >
            <UploadCommon
              :fileList="businessLicenceUrl"
              :isAlone="true"
              @uploadSuccess="businessLicenceSuccess"
              @deleteUploadHandle="delBusinessLicenceUrl"
              :sizeType="4"
              commonUpload
              group="assert"
              code="assert_business_license"
            ></UploadCommon>
          </el-form-item>
        </el-col>
      <!-- </column-box> -->
      <!-- 表单 -->
      <!-- <column-box :column="3" label-width="150px"> -->
        <el-col :span="8">
          <el-form-item
            prop="customerType"
            :label="`客户类型${columnSeparator}`"
          >
            <span>{{customertypeDictList[addFormData.customerType]}}</span>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            prop="source"
            :label="`客户来源${columnSeparator}`"
          >
            <el-select
              placeholder="请选择"
              v-model="publicInfo.source"
              clearable
            >
              <el-option
                v-for="item in customerSourceList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
          prop="customerName"
          >
          <template #label>
            {{`客户名称${columnSeparator}`}}
            <el-tooltip v-if="enableModified" class="item" effect="dark" placement="bottom">
              <template #content>
                此信息已通过三方实名认证，不可修改
              </template>
              <i class="el-icon-question"></i>
            </el-tooltip>
          </template>
            <el-input
              :disabled="enableModified"
              v-space="true"
              v-model="publicInfo.customerName"
              placeholder="请输入"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            prop="creditCode"
            v-if="addFormData.customerType === 2"
            :label="`统一社会信用代码${columnSeparator}`"
          >
            <el-input
              v-alphanumeric="true"
              v-model="enterpriseCustomerInfo.creditCode"
              placeholder="请输入"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            prop="legalPersonName"
            v-if="addFormData.customerType === 2"
            :label="`法人姓名${columnSeparator}`"
          >
            <el-input
              v-space="true"
              v-model="enterpriseCustomerInfo.legalPersonName"
              placeholder="请输入"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            prop="legalIdCardNo"
            v-if="addFormData.customerType === 2"
            :label="`法人身份证号${columnSeparator}`"
          >
            <el-input
              v-alphanumeric="true"
              v-model="enterpriseCustomerInfo.legalIdCardNo"
              placeholder="请输入"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            prop="contacts"
            v-if="addFormData.customerType === 2"
            :label="`联系人姓名${columnSeparator}`"
            :rules="[{ required: true, message: '联系人姓名不能为空', trigger: 'change' }]"
          >
            <el-input
              v-space="true"
              v-model="publicInfo.contacts"
              placeholder="请输入"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            prop="idCardNo"
            v-if="addFormData.customerType === 1"
            :rules="[
              { required: true, message: '证件号码不能为空', trigger: 'change' },
              { required: true, validator: getIdentity, trigger: 'change' }
            ]"
          >
          <template #label>
            {{`证件号码${columnSeparator}`}}
            <el-tooltip v-if="enableModified" class="item" effect="dark" placement="bottom">
              <template #content>
                此信息已通过三方实名认证，不可修改
              </template>
              <i class="el-icon-question"></i>
            </el-tooltip>
          </template>
            <el-input
              maxlength="18"
              v-alphanumeric="true"
              v-model="publicInfo.idCardNo"
              placeholder="请输入"
              clearable
              :disabled="enableModified"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            v-if="addFormData.customerType === 1"
            prop="idCardValidDate"
            :label="'身份证有效期' + columnSeparator"
          >
            <el-date-picker
              v-model="individualCustomerInfo.idCardValidDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              format="yyyy-MM-dd"
              clearable
            >
            </el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            v-if="addFormData.customerType === 1"
            prop="ethnicity"
            :label="`民族${columnSeparator}`"
          >
            <el-select
              placeholder="请选择"
              v-model="individualCustomerInfo.ethnicity"
              clearable
            >
              <el-option
                v-for="item in nationList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            v-if="addFormData.customerType === 1"
            prop="registeredResidence"
            :label="`户籍地址${columnSeparator}`"
          >
            <el-input
              type="textarea"
              v-model="individualCustomerInfo.registeredResidence"
              placeholder="请输入"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            v-if="addFormData.customerType === 1"
            prop="issuanceAuthority"
            :label="`签发机关${columnSeparator}`"
          >
            <el-input
              v-space="true"
              v-model="individualCustomerInfo.issuanceAuthority"
              placeholder="请输入"
              clearable
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            prop="customerTel"
            :label="`联系电话${columnSeparator}`"
          >
            <el-input
              v-model="publicInfo.customerTel"
              placeholder="请输入"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            prop="emergencyContact"
            v-if="addFormData.customerType === 1"
            :label="`紧急联系人${columnSeparator}`"
          >
            <el-input
              v-space="true"
              v-model="individualCustomerInfo.emergencyContact"
              placeholder="请输入"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            prop="emergencyContactRelation"
            v-if="addFormData.customerType === 1"
            :label="`紧急联系人关系${columnSeparator}`"
          >
            <el-input
              v-space="true"
              v-model="individualCustomerInfo.emergencyContactRelation"
              placeholder="请输入"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            prop="emergencyContactTel"
            v-if="addFormData.customerType === 1"
            :label="`紧急联系人电话${columnSeparator}`"
          >
            <el-input
              v-number:phone
              v-model="individualCustomerInfo.emergencyContactTel"
              placeholder="请输入"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            prop="address"
            :label="`客户地址${columnSeparator}`"
          >
            <el-input
              type="textarea"
              v-model="publicInfo.address"
              placeholder="请输入"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            prop="remarks"
            :label="`备注${columnSeparator}`"
          >
            <el-input
              type="textarea"
              v-model="publicInfo.remarks"
              placeholder="请输入"
              clearable
              maxlength="500"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>

      <!-- </column-box> -->
    </el-form>
  </div>
</template>

<script>
import selectOption from '@/store/dict/selectOptionDict'
import driverDict from '@/store/dict/driverDict'
import {
  getIdentity,
  validateAccountCustomerName,
  isDate,
  validatePhoneNumber,
} from '@/utils/extendFormVaildate'

import {
  ocrIdcard,
} from '@/api/company'
import AlipayAnxinCard from './AlipayAnxinCard'

export default {
  name: 'AddCustomerBasicInfo',
  components: {
    AlipayAnxinCard,
  },
  props: {
    addFormData: {
      type: Object,
      default: () => ({}),
    },
    sourceRequired: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    addFormData: {
      handler(val) {
        // 回显
        if (Number(this.addFormData.customerType) === 1 && val.individualCustomerVo) {
          this.idCardUrl = val.individualCustomerVo.idCardUrl || []
          this.idCardBackUrl = val.individualCustomerVo.idCardBackUrl || []
          this.individualCustomerInfo = {
            idCardUrl: val.individualCustomerVo.idCardUrl || '',
            idCardBackUrl: val.individualCustomerVo.idCardBackUrl || '',
            customerType: val.customerType, // 客户类型
            idCardValidDate: val.individualCustomerVo.idCardValidDate || '', // 身份证有效期
            ethnicity: this.getNationValue(val.individualCustomerVo.ethnicity), // 民族
            registeredResidence: val.individualCustomerVo.registeredResidence || '', // 户籍地址
            issuanceAuthority: val.individualCustomerVo.issuanceAuthority || '', // 签发机关
            emergencyContact: val.individualCustomerVo.emergencyContact || '', // 紧急联系人
            emergencyContactRelation: val.individualCustomerVo.emergencyContactRelation || '', // 紧急联系人关系
            emergencyContactTel: val.individualCustomerVo.emergencyContactTel || '', // 紧急联系人电话
          }

          this.publicInfo = {
            idCardNo: val.individualCustomerVo.idCardNo || '', // 证件号码
            source: val.source || '', // 客户来源
            customerName: val.customerName || '', // 客户名称
            customerTel: val.customerTel || '', // 联系电话
            address: val.address || '', // 客户地址
            remarks: val.remarks || '', // 备注
          }
        } else if (Number(this.addFormData.customerType) === 2 && val.enterpriseCustomerVo) {
          this.publicInfo = {
            source: val.source || '', // 客户来源
            customerName: val.customerName || '', // 客户名称
            customerTel: val.customerTel || '', // 联系电话
            address: val.address || '', // 客户地址
            remarks: val.remarks || '', // 备注
            contacts: val.enterpriseCustomerVo.contacts || '', // 联系人姓名
          }
          this.enterpriseCustomerInfo = {
            businessLicenceUrl: val.enterpriseCustomerVo.businessLicenceUrl || '', // 营业执照
            creditCode: val.enterpriseCustomerVo.creditCode || '', // 统一社会信用代码
            legalPersonName: val.enterpriseCustomerVo.legalPersonName || '', // 法人姓名
            legalIdCardNo: val.enterpriseCustomerVo.legalIdCardNo || val.enterpriseCustomerVo.idCardNo || '', // 法人身份证号
          }
          this.businessLicenceUrl = val.enterpriseCustomerVo.businessLicenceUrl || []
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      idCardUrl: [],
      idCardBackUrl: [],
      businessLicenceUrl: [],
      getIdentity,
      // 个人
      individualCustomerInfo: {
        idCardUrl: '', // 身份证照片（正）
        idCardBackUrl: '', // 身份证照片（背）
        // customerType: this.addFormData.customerType, // 客户类型
        idCardValidDate: '', // 身份证有效期
        ethnicity: '', // 民族
        registeredResidence: '', // 户籍地址
        issuanceAuthority: '', // 签发机关
        emergencyContact: '', // 紧急联系人
        emergencyContactRelation: '', // 紧急联系人关系
        emergencyContactTel: '', // 紧急联系人电话
      },
      // 企业
      enterpriseCustomerInfo: {
        businessLicenceUrl: '', // 营业执照
        creditCode: '', // 统一社会信用代码
        legalPersonName: '', // 法人姓名
        legalIdCardNo: '', // 法人身份证号
      },
      // 公共
      publicInfo: {
        contacts: '', // 联系人姓名
        idCardNo: '', // 个人客户证件号码
        source: '', // 客户来源
        customerName: '', // 客户名称
        customerTel: '', // 联系电话
        address: '', // 客户地址
        remarks: '', // 备注
      },
    }
  },
  computed: {
    formRule() {
      return {
        source: this.sourceRequired
          ? [{ required: true, message: '客户来源不能为空', trigger: 'change' }]
          : [],
        customerName: [
          { required: true, message: '客户名称不能为空', trigger: 'change' },
          { required: true, validator: validateAccountCustomerName, trigger: 'change' },
        ],
        customerTel: [
          // { required: true, min: 11, max: 11, message: '联系电话不能为空', trigger: 'change' },
          { required: true, validator: validatePhoneNumber, trigger: 'change' },
        ],
      }
    },
    // 客户来源
    customerSourceList() {
      return this.dictParseList(selectOption.customerSourceList)
    },
    // 民族
    nationList() {
      const nationDict = driverDict.NATION_DICT()
      return Object.keys(nationDict).map((key) => ({
        value: nationDict[key],
        label: nationDict[key],
      }))
    },
    // 客户类型
    customertypeDictList() {
      return selectOption.customertypeDict
    },
    // 客户姓名和身份证号是否可以修改
    enableModified() {
      const vars = this.addFormData.individualCustomerVo || {}
      return Object.prototype.hasOwnProperty.call(vars, 'idCardNoLock') && Boolean(vars.idCardNoLock)
    },
    showAlipayAnxinCard() {
      return Number(this.addFormData.customerType) === 1
    },
  },
  methods: {
    getNationValue(value) {
      if (!value) return ''
      return driverDict.NATION_DICT()[value] || value
    },
    getAnxinCardValue(data, keys) {
      const key = keys.find((item) => data[item])
      return key ? data[key] : ''
    },
    handleAlipayAnxinCardData(data = {}) {
      const customerName = this.getAnxinCardValue(data, ['user_name', 'userName', 'customerName'])
      const customerTel = this.getAnxinCardValue(data, ['phone_number', 'phoneNumber', 'customerTel'])
      const idCardNo = this.getAnxinCardValue(data, ['id_card_number', 'idCardNumber', 'idCardNo'])
      const publicInfo = { ...this.publicInfo }

      if (customerTel) {
        publicInfo.customerTel = customerTel
      }
      if (!this.enableModified) {
        if (customerName) {
          publicInfo.customerName = customerName
        }
        if (idCardNo) {
          publicInfo.idCardNo = idCardNo
        }
      }

      this.publicInfo = publicInfo
      this.$nextTick(() => {
        this.$refs.addCustomerBasicInfo?.clearValidate(['customerName', 'idCardNo', 'customerTel'])
      })
    },
    // 身份证（正）
    idCardSuccess(url) {
      this.individualCustomerInfo.idCardUrl = JSON.stringify([url])
      ocrIdcard({ imageUrl: url }).then((res) => {
        const { code, data } = res
        if (code === 1) {
          const { name, id, address } = data
          this.individualCustomerInfo.registeredResidence = address || ''
          this.publicInfo = Object.assign({}, this.publicInfo, {
            idCardNo: id,
            customerName: name,
            address,
          })
        }
      })
    },
    // 身份证（背）
    idCardBackSuccess(url) {
      this.individualCustomerInfo.idCardBackUrl = JSON.stringify([url])
      ocrIdcard({ imageUrl: url }).then((res) => {
        const { code, data } = res
        if (code === 1) {
          const { validDate, authority, issuingAuthority, issueAuthority } = data
          this.individualCustomerInfo.idCardValidDate = isDate(validDate) ? validDate : ''
          this.individualCustomerInfo.issuanceAuthority =
            authority || issuingAuthority || issueAuthority || ''
        }
      })
    },
    // 营业执照
    businessLicenceSuccess(url) {
      this.enterpriseCustomerInfo.businessLicenceUrl = JSON.stringify([url])
      /**
       * 因使用的腾讯云下架了对营业执照的OCR能力，服务端切换到别的供应商
       * （阿里云或别家）需要开发代码，需要一定的时间所以前端先暂时下线OCR能力
       * 下面代码勿删
       * https://devops.aliyun.com/projex/project/83dc9efb9a32b55374287ac3e0/bug/b5979c80317b04a860efa98a8c
       * */
      // ocrBizLicense({ imageUrl: url }).then(res => {
      //   const { code, data } = res
      //   if (code === 1) {
      //     const { frName, entName, dom } = data
      //     this.publicInfo = Object.assign({}, this.publicInfo, {
      //       customerName: entName,
      //       address: dom,
      //     })
      //     this.enterpriseCustomerInfo.legalPersonName = frName
      //   }
      // })
    },
    // eslint-disable-next-line vue/no-unused-properties
    validate() {
      let flag = false
      this.$refs.addCustomerBasicInfo.validate((valid) => {
        if (valid) {
          if (Number(this.addFormData.customerType) === 1) {
            this.individualCustomerInfo = {
              ...this.addFormData.individualCustomerInfo,
              ...this.individualCustomerInfo,
              idCardNo: this.publicInfo.idCardNo,
            }
            if (this.individualCustomerInfo.idCardValidDate === '长期') {
              this.individualCustomerInfo.idCardValidDate = '2099-09-09'
            }
          } else if (Number(this.addFormData.customerType) === 2) {
            this.enterpriseCustomerInfo = {
              ...this.addFormData.enterpriseCustomerInfo,
              ...this.enterpriseCustomerInfo,
              contacts: this.publicInfo.contacts,
            }
          }
        }
        flag = valid
      })

      return flag
    },
    // 营业执照照片删除事件
    delBusinessLicenceUrl() {
      this.enterpriseCustomerInfo.businessLicenceUrl = null
    },
    // 身份证照片（正）删除事件
    delIdCardUrl() {
      this.individualCustomerInfo.idCardUrl = null
    },
    // 身份证照片（反）删除事件
    delIdCardBackUrl() {
      this.individualCustomerInfo.idCardBackUrl = null
    },
  },
}
</script>
